const UPDATE_APPLICATION_NAME = 'UPDATE_APPLICATION_NAME';
export default UPDATE_APPLICATION_NAME;